<div class="content-area sdps-p-around_large">
        {{healthMsg}}
</div>
